import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Formik, Form, Field, useFormik } from 'formik';
import srpBg1 from '../assets/images/srp-hero-bg.webp';
import { getImages } from '../Components/Common/const';
import SrpList from '../Components/Srp/SrpList';
import ModalLayout from '../Components/Common/ModalLayout';
import SelectFilterModal from '../Components/Srp/SelectFilterModal';
import { VehicleContext } from '../Components/Context/VehicleContext';
import MoreFilterModal from '../Components/Srp/MoreFilterModal';
import { useLocation } from 'react-router-dom';
import SeoMeta from '../Components/Common/SeoMeta';
import { Helmet } from 'react-helmet';

// const images = [srpBg1, srpBg2, srpBg3];

const Srp = () => {
    const { 
        getVehicleData, 
        vehicleData, 
        filteredVehicleData, 
        searchText, setSearchText, 
        numberFormatter, currentFilterData, 
        setCurrentFilterData, activeFilter, 
        setActiveFilter, priceFilterData, 
        setPriceFilterData, mileageFilterData, 
        setMileageFilterData, 
        priceFormatter 
    } = useContext(VehicleContext);
    
    // const [vehicleSearchText, setVehicleSearchText] = useState("");
    const searchInputChanged = (val) => {
        setSearchText(val);
    }
    const [isSticky, setIsSticky] = useState(false);
    //const [srpFilter, setSrpFilter] = useState(false);
    //const [pageSize, setPageSize] = useState(50);
    const [isDataLoaded, setIsDataLoaded] = useState(true);
    const [isOpacity, setIsOpacity] = useState(true);

    const [value, setValue] = useState([priceFilterData.min, priceFilterData.max]);

    const handleInputChange = (index, event) => {
        let newValue = Number(event.target.value);
        if (!isNaN(newValue)) {
            const updatedValues = [...value];

            if (index === 0) {
                updatedValues[0] = newValue;
                if (newValue > updatedValues[1]) {
                    updatedValues[1] = newValue;
                }
            } else {
                updatedValues[1] = Math.max(newValue, updatedValues[0]);
            }
            setValue(updatedValues);
        }
    };

    const handlePriceSliderChange = (newValue) => {
        setPriceFilterData({ ...priceFilterData, ['current_min']: newValue[0], ['current_max']: newValue[1] });
    };

    const handleMileageSliderChange = (newValue) => {
        setMileageFilterData({ ...mileageFilterData, ['current_min']: newValue[0], ['current_max']: newValue[1] });
    };
    const [mobFilter, setMobFilter] = useState(false);
    const handleFilterBtn = () => {
        setMobFilter(!mobFilter)
    }
    const handleCloseFilter = () => {
        setMobFilter(false)
    }
    var srpCarSlider = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
        pauseOnHover: false,
    };


    useEffect(() => {
        if (filteredVehicleData) {
            setIsDataLoaded(false);
            setTimeout(() => {
                setIsOpacity(false);
            }, 100);
        }
        //console.log("filtered vehicle data", filteredVehicleData);
        //console.log("current filters",currentFilterData);
    }, [filteredVehicleData]);



    useEffect(() => {
        // console.log("srp useEffect");

        getVehicleData();

        const handleScroll = () => {
            const topSection = document.getElementById('srpFilter');
            if (topSection) {
                const topSectionRect = topSection.getBoundingClientRect();
                const isTopSectionVisible = topSectionRect.top <= 0;
                setIsSticky(isTopSectionVisible);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {

        const handleScroll = () => {
            const topSection = document.getElementById('srpFilter');
            if (topSection) {
                const topSectionRect = topSection.getBoundingClientRect();
                const isTopSectionVisible = topSectionRect.top <= 0;
                setIsSticky(isTopSectionVisible);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const [openFilterModal, setOpenFilterModal] = useState(false);

    const [filterData, setFilterData] = useState([]);

    const handleFilterModal = (field) => {
        setOpenFilterModal(true);

        setFilterData(currentFilterData[field]);
        setActiveFilter(field);
    };
    const closeMakeModal = () => {
        setOpenFilterModal(false)
    }

    const updateFilter = (filter_data) => {
        setCurrentFilterData({ ...currentFilterData, [activeFilter]: filter_data });
    }

    const clearFilter = (field) => {
        // console.log(field);
        // console.log(currentFilterData[field]);

        const filter_data = [];

        if (currentFilterData[field]) currentFilterData[field].forEach((v) => {
            filter_data.push({ ...v, isSelected: false })
        });

        setCurrentFilterData({ ...currentFilterData, [field]: filter_data });
    }

    const clearAllFilters = () => {
        clearFilter('year');
        clearFilter('make');
        clearFilter('model');
        clearFilter('trim');
        clearFilter('body_style');

        handlePriceSliderChange([priceFilterData.min, priceFilterData.max]);
        handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]);

        const filter_data = {};

        Object.keys(currentFilterData).map((field) => {
            filter_data[field] = [];
            currentFilterData[field].forEach((v) => {
                filter_data[field].push({ ...v, isSelected: false })
            });
        });

        setCurrentFilterData(filter_data);
    }

    const openVDP = (vdp_url) => {
        window.location.href = "/vehicle-details/" + vdp_url;
    }




    const queryParameters = new URLSearchParams(window.location.search);
    const vehicleMake = queryParameters.get("make");

    useEffect(() => {

        clearAllFilters();

        if (vehicleMake) {

            const filter_data = currentFilterData.make.map((v, i) => {
                return v.name.toLowerCase() == vehicleMake.toLowerCase() ? { ...v, "isSelected": true } : v;
            });

            setCurrentFilterData({ ...currentFilterData, ["make"]: filter_data });

        }

        // console.log("make test", vehicleMake, currentFilterData);

    }, [vehicleMake, vehicleData]);

    // const location = useLocation();

    // useEffect(() => {
    //     const preselected = location.state?.preselectedLocation;

    //     if (preselected) {
    //         setLocationFilters([preselected]);
    //     }
    // }, [location.state?.preselectedLocation]);


    const [isSlMobile, setIsSlMobile] = useState(false);
    const handleSlResize = () => {
        setIsSlMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleSlResize();
        window.addEventListener('resize', handleSlResize);
        return () => {
            window.removeEventListener('resize', handleSlResize);
        };
    }, []);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const handleMouseEnter = (index) => {
        setHoveredIndex(index);
    };
    const handleMouseLeave = () => {
        setHoveredIndex(null);
    };

    // Sort By data 
    const [sortColumn, setSortColumn] = useState('utc_inventory_date');
    const [sortSelectValue, setSortSelectValue] = useState('utc_inventory_date');
    const [sortOrder, setSortOrder] = useState(1);
    const handleSortByChange = (e) => {
        const sort_val = e.target.value;
        setSortSelectValue(sort_val);
        setSortOrder(sort_val.includes("_low") ? -1 : 1);
        setSortColumn(sort_val.replace("_low", ""));

        //console.log(sort_val,sort_val.includes("_low") ? -1 : 1)
    };
    // const totalFilterCount =
    //     locationFilters.length +
    //     ((priceFilterData.current_min > priceFilterData.min || priceFilterData.current_max < priceFilterData.max) ? 1 : 0) +
    //     ((mileageFilterData.current_min > mileageFilterData.min || mileageFilterData.current_max < mileageFilterData.max) ? 1 : 0) +
    //     Object.values(currentFilterData).reduce((count, items) => {
    //         return count + items.filter(item => item.isSelected).length;
    //     }, 0);


    const [bgImage, setBgImage] = useState(srpBg1);

    const [filerOptionsOpen, setFilerOptionsOpen] = useState(false);
    const handleMobFilterBtn = () => {
        setFilerOptionsOpen(true)
    }
    const closeSrpFilter = () => {
        setFilerOptionsOpen(false)
    }

    // More Filter Modal
    const [openMoreModal, setOpenMoreModal] = useState(false);
    const handleFilterMoreModal = () => {
        setOpenMoreModal(true);
        document.body.classList.add('body-overflow');
    }
    const closeFilterMoreModal = () => {
        setOpenMoreModal(false)
        document.body.classList.remove('body-overflow');
    }
    // For mobile View Condition

    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <>
            <Helmet>
                <title>Pre-Owned Mercedes-Benz Inventory | Pompano Beach, FL</title>
                <meta name="description" content="Explore certified pre-owned Mercedes-Benz sedans, coupes, and SUVs – inspected and ready to drive home today." />
                <meta name="keywords" content="" />
                <meta property="og:title" content="Pre-Owned Mercedes-Benz Inventory | Pompano Beach, FL" />
                <meta property="og:description" content="Explore certified pre-owned Mercedes-Benz sedans, coupes, and SUVs – inspected and ready to drive home today." />
            </Helmet>
            <section className='srp-wrap'
                style={{
                    background: `#222 url(${bgImage}) no-repeat center top`,
                }}
            >
                <div className='srp-top-block'>
                    <div className='container'>
                        <div className='d-flex align-items-center justify-content-between mb-3 srpt-title'>
                            <div className='lg-title font-3em fw-500 text-start mb-lg-3'>Search Results</div>
                            <div className="d-lg-none">
                                <button type="button" className="filter-btn" onClick={handleMobFilterBtn}>
                                    Filters
                                    <img alt="icon" src={getImages('filter_icon.svg')} />
                                </button>
                            </div>
                        </div>
                        <div className='d-flex align-items-center justify-content-between search-flex mb-3'>
                            <div className='d-flex search-box'>
                                <input type='text' className='form-control'
                                    placeholder='Search'
                                    value={searchText}
                                    onChange={(e) => { searchInputChanged(e.target.value) }}
                                />
                                <button className='search-btn'><span className='search-icon'></span></button>
                            </div>
                            <div className={`d-lg-inline-flex align-items-start srp-filter-block ${filerOptionsOpen ? '' : 'd-none'}`}>
                                <div className='srp-filter-header d-lg-none d-flex align-items-center justify-content-between'>
                                    <div>Filters</div>
                                    {/* <button className='sf-close-icon' onClick={closeSrpFilter} type='button'><img src={getImages('cross_icon.svg')} /></button>
                                     */}
                                    <button className="sm-box-close" type="button" onClick={closeSrpFilter}>
                                        <img src={getImages('white-close.svg')}/>
                                    </button>
                                </div>
                                <div className='srp-filter-body d-inline-flex gap-3'>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('year')}>
                                        <img src={getImages('year-icon.png')} />
                                        <span>Year</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('make')}>
                                        <img src={getImages('make-icon.png')} />
                                        <span>Make</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('model')}>
                                        <img src={getImages('model-icon.png')} />
                                        <span>Model</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={() => handleFilterModal('body_style')}>
                                        <img src={getImages('trim-icon.png')} />
                                        <span>Body Type</span>
                                    </button>
                                    <button type='button' className='fl-btn' onClick={handleFilterMoreModal}>
                                        <img src={getImages('more-icon.png')} />
                                        <span>More</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='selected-block d-md-flex align-items-center mb-1'>
                            <div className='xs-title fl-items-count me-3 mb-md-0 mb-1'>{filteredVehicleData ? filteredVehicleData.length : ""}  Results</div>
                            <div className='d-flex align-items-center fl-tags'>
                                {/* <div className='fl-tag'><span>2022-2023</span> <button type='button' className='close-icon'></button></div>
                            <div className='fl-tag'><span>1k-20k</span> <button type='button' className='close-icon'></button></div>
                             */}
                                {/* {locationFilters.map((item, index) =>
                                    <div className='fl-tag me-2 mb-0' key={index}>{item}
                                        <img
                                            src={getImages('cross_icon.svg')}
                                            alt="Remove"
                                            onClick={() => {
                                                clearFilter(item);

                                                setLocationFilters(locationFilters.filter((location) => location !== item));
                                            }}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </div>
                                )} */}
                                {(priceFilterData.current_min > priceFilterData.min || priceFilterData.current_max < priceFilterData.max) && <div className='priceFilterData fl-tag me-2 mb-0'>Price {priceFilterData.current_min == priceFilterData.min ? "Min" : numberFormatter(priceFilterData.current_min, true)} - {priceFilterData.current_max == priceFilterData.max ? "Max" : numberFormatter(priceFilterData.current_max, true)} <img src={getImages('cross_icon.svg')} onClick={() => { handlePriceSliderChange([priceFilterData.min, priceFilterData.max]) }} /></div>}
                                {(mileageFilterData.current_min > mileageFilterData.min || mileageFilterData.current_max < mileageFilterData.max) && <div className='mileageFilterData fl-tag me-2 mb-0'>Mileage {mileageFilterData.current_min == mileageFilterData.min ? "Min" : numberFormatter(mileageFilterData.current_min)} - {mileageFilterData.current_max == mileageFilterData.max ? "Max" : numberFormatter(mileageFilterData.current_max)} <img src={getImages('cross_icon.svg')} onClick={() => { handleMileageSliderChange([mileageFilterData.min, mileageFilterData.max]) }} /></div>}
                                {Object.keys(currentFilterData)
                                    .filter((key) =>
                                        key.trim() !== '' && // Exclude blank keys
                                        Array.isArray(currentFilterData[key]) &&
                                        currentFilterData[key].some(item => item && item.isSelected)
                                    )
                                    .map((key, index) => {
                                        const displayLabel = key === 'body_style' ? 'Body Style' : key;
                                        return (
                                            <div className='fl-tag me-2 mb-0' key={index}>
                                                {displayLabel}
                                                <img
                                                    src={getImages('cross_icon.svg')}
                                                    alt="Remove"
                                                    onClick={() => clearFilter(key)}
                                                    style={{ cursor: "pointer" }}
                                                />
                                            </div>
                                        );
                                    })}

                            </div>
                        </div>
                    </div>
                </div>
                <SrpList
                    filteredVehicleData={filteredVehicleData}
                    numberFormatter={numberFormatter}
                    priceFormatter={priceFormatter}
                    isMobile={isMobile}
                />
            </section>

            {openFilterModal &&
                <ModalLayout open={openFilterModal} close={closeMakeModal} darkThemeCls='true' modalWidth={970}>
                    <SelectFilterModal close={closeMakeModal} filterData={filterData} updateFilter={updateFilter} activeFilter={activeFilter} />
                </ModalLayout>
            }
            {openMoreModal &&
                <ModalLayout open={openMoreModal} close={closeFilterMoreModal} darkThemeCls='true' modalWidth={970}>
                    <MoreFilterModal
                        close={closeFilterMoreModal}
                        numberFormatter={numberFormatter}
                        handlePriceSliderChange={handlePriceSliderChange}
                        priceFilterData={priceFilterData}
                        setPriceFilterData={setPriceFilterData}
                        handleMileageSliderChange={handleMileageSliderChange}
                        setMileageFilterData={setMileageFilterData}
                        handleInputChange={handleInputChange}
                        mileageFilterData={mileageFilterData}
                        isMobile={isMobile}
                        // locationFilters={locationFilters}
                        // setLocationFilters={setLocationFilters}
                    />
                </ModalLayout>
            }
        </>
    )
}

export default Srp